import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import ShiftPerformanceContent from './ShiftPerformanceContent';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SmallDonutChart from './Charts/SmallDonutChart';
import MessageContent from '../Dashboard/MessageContent'


export default function ProductionLineContent(props) {
    const classes = useStyles();
    const [workstationStatusses, setWorkstationStatusses] = useState([]);


    useEffect(() => {
        let mounted = true
        dataService.getWorkstationStatusses().then(statusses => {
            if (mounted) {
                if (workstationStatusses.length !== statusses.body.length) {
                    setWorkstationStatusses(statusses.body)
                }
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        return function cleanup() {
            mounted = false
        }
    }, []);

    let statusColor = "";
    let icon = <React.Fragment></React.Fragment>
    let statusType = "";
    if (workstationStatusses.length > 0) {

        statusType = workstationStatusses.find(x => x.id === props.workstation.status).type

        switch (statusType) {
            case "warning":
                statusColor = "#F59128";
                icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
                break;
            case "error":
                statusColor = "#D84949";
                icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
                break;
            case "running":
                statusColor = "#5CC958";
                icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
                break;
            default:
        }
    }

    return (
        <React.Fragment>
            <div className={classes.productionLineContainer} style={{ border: props.border }}>
                <div className={classes.header}>
                    <div className={classes.workstationId}>
                        {props.workstation.id}
                    </div>
                    <div className={classes.border1}>
                    </div>
                    <div className={classes.statusContainer}>
                        <div className={classes.status}>
                            <div className={classes.statusIcon} style={{ color: statusColor }}>
                                {icon}
                            </div>
                            <div className={classes.statusText} style={{ color: statusColor }}>
                                {statusType}
                            </div>
                        </div>
                        <div className={classes.duration}>
                            {props.workstation.statusDuration}
                        </div>
                    </div>
                </div>
                <ShiftPerformanceContent workstation={props.workstation}></ShiftPerformanceContent>
                <div className={classes.border2}></div>
                <div className={classes.performanceSharts}>
                    <SmallDonutChart value={props.workstation.quality} label={"Quality"}></SmallDonutChart>
                    <SmallDonutChart value={props.workstation.performance} label={"Performance"}></SmallDonutChart>
                    <SmallDonutChart value={props.workstation.availability} label={"Availability"}></SmallDonutChart>
                </div>
                <div className={classes.border3}></div>
                <div className={classes.messagesContainer}>
                    {props.workstation.messages.slice(props.workstation.messages.length -2,props.workstation.messages.length).map(x => <MessageContent key={x.id} message={x} textWidth = {"240px"} iconPadding = {"8px"} messageHeight = {"65px"} backgroundColor= {"#F4F4F4"}></MessageContent>)}
                </div>
            </div>
        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    productionLineContainer: {
        width: "300px",
        height: "655px",
        backgroundColor: "white",
        float: "left",
        margin: "5px",
        borderRadius: "5px",
        padding: "15px",
        boxSizing: "borderBox"
    },
    errorIcon: {
        width: "27px",
        height: "27px",
    },
    infoIcon: {
        width: "27px",
        height: "27px",

    },
    workstationId: {
        fontSize: "67px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#DEDEDE',
        width: "80px",
        height: "80px",
        float: "left"
    },
    border1: {
        float: "left",
        width: "15px",
        height: "60px",
        marginTop: "10px",
        borderRight: "1px solid #DEDEDE"
    },
    border2: {
        width: "100%",
        height: "5px",
        borderBottom: "1px solid #DEDEDE"
    },
    border3: {
        width: "100%",
        height: "150px",
        borderBottom: "1px solid #DEDEDE",
        marginBottom:"20px"
    },
    header: {
        width: "100%",
        height: "85px",
        borderBottom: "1px solid #DEDEDE",
        marginBottom: "15px"
    },
    statusContainer: {
        float: "left",
        padding: "10px",
        paddingTop: "15px",
        paddingLeft: "15px"

    },
    statusText: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textTransform: "capitalize",
        float: "left",
        position: "relative",
        bottom: "2px"
    },
    statusIcon: {
        float: "left",
        marginRight: "5px"

    },
    duration: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100"
    },
    status: {
        width: "150px",
        height: "35px"
    }
}));